import { _lang } from '@umu/ukit-lang';
import dayjs from 'dayjs';

import zhCN from '@umu/umu-picker/lib/locale/zh_CN.js';
import 'dayjs/locale/zh-cn';

import enUS from '@umu/umu-picker/lib/locale/en_US.js';
import 'dayjs/locale/en';

import esES from '@umu/umu-picker/lib/locale/es_ES.js';
import 'dayjs/locale/es';

import jaJP from '@umu/umu-picker/lib/locale/ja_JP.js';
import 'dayjs/locale/ja';

import zhTW from '@umu/umu-picker/lib/locale/zh_TW.js';
import 'dayjs/locale/zh-tw';

import koKR from '@umu/umu-picker/lib/locale/ko_KR.js';
import 'dayjs/locale/ko';

import frFR from '@umu/umu-picker/lib/locale/fr_FR.js';
import 'dayjs/locale/fr';

import idID from '@umu/umu-picker/lib/locale/id_ID.js';
import 'dayjs/locale/id';

import ruRU from '@umu/umu-picker/lib/locale/ru_RU.js';
import 'dayjs/locale/ru';

import ptBR from '@umu/umu-picker/lib/locale/pt_BR.js';
import 'dayjs/locale/pt';

import deDE from '@umu/umu-picker/lib/locale/de_DE.js';
import 'dayjs/locale/de';

import itIT from '@umu/umu-picker/lib/locale/it_IT.js';
import 'dayjs/locale/it';

import viVN from '@umu/umu-picker/lib/locale/vi_VN.js';
import 'dayjs/locale/vi';

import svSE from '@umu/umu-picker/lib/locale/sv_SE.js';
import 'dayjs/locale/sv';

import nlNL from '@umu/umu-picker/lib/locale/nl_NL.js';
import 'dayjs/locale/nl';
interface ILocaleConfigType {
    locale: any;
    dateDisplayFormat: string;
}

const localeConfig: ILocaleConfigType = {
    locale: enUS,
    dateDisplayFormat: 'ddd, MMM DD, YYYY HH:mm',
};

if (_lang('CN')) {
    dayjs().locale('zh-cn').format();
    localeConfig.locale = zhCN;
    localeConfig.dateDisplayFormat = 'YYYY年MM月DD日 dddd HH:mm';
}

if (_lang('EN')) {
    dayjs().locale('en').format();
    localeConfig.locale = enUS;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('ES')) {
    dayjs().locale('es').format();
    localeConfig.locale = esES;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('FR')) {
    dayjs().locale('fr').format();
    localeConfig.locale = frFR;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('JP')) {
    dayjs().locale('ja').format();
    localeConfig.locale = jaJP;
    localeConfig.dateDisplayFormat = 'YYYY年MM月DD日 dddd HH:mm';
}

if (_lang('TW')) {
    dayjs().locale('zh-tw').format();
    localeConfig.locale = zhTW;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('KO')) {
    dayjs().locale('ko').format();
    localeConfig.locale = koKR;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('RU')) {
    dayjs().locale('ru').format();
    localeConfig.locale = ruRU;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('ID')) {
    dayjs().locale('id').format();
    localeConfig.locale = idID;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('PT')) {
    dayjs().locale('pt').format();
    localeConfig.locale = ptBR;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('DE')) {
    dayjs().locale('de').format();
    localeConfig.locale = deDE;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('IT')) {
    dayjs().locale('it').format();
    localeConfig.locale = itIT;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('VI')) {
    dayjs().locale('vi').format();
    localeConfig.locale = viVN;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('SV')) {
    dayjs().locale('sv').format();
    localeConfig.locale = svSE;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

if (_lang('NL')) {
    dayjs().locale('nl').format();
    localeConfig.locale = nlNL;
    localeConfig.dateDisplayFormat = 'ddd, MMM DD, YYYY HH:mm';
}

export { localeConfig };
